import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TestListingCard from '../../components/generic/TestListingCard';
import { AllTestsListSkeleton } from './AllTestsListSkeleton';
import { usePackStorage } from '../../Layout/usePackStorage';

export default function AllTestsList({ packId }) {
  const { freePacks, purchasedPacks } = usePackStorage();
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showLeftShadow, setShowLeftShadow] = useState(false);
  const [showRightShadow, setShowRightShadow] = useState(false);
  const scrollContainerRef = useRef(null);
  let navigate = useNavigate();

  useEffect(() => {
    const fetchAllTests = async () => {
      setLoading(true);
      setError(null);
      if (packId) {
        try {
          const response = await axios.get(
            `/api/packs/v2/dashboard/${packId}/${purchasedPacks[0]?.group?.[0]?._id}/tests`,
          );
          setApiData(response?.data?.data);
        } catch (err) {
          console.error('API Error:', err);
          setError(err.message);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchAllTests();
  }, [packId, freePacks]);

  const handleScroll = () => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const { scrollLeft, scrollWidth, clientWidth } = container;
    const isScrollable = scrollWidth > clientWidth;

    if (!isScrollable) {
      setShowLeftShadow(false);
      setShowRightShadow(false);
      return;
    }

    setShowLeftShadow(scrollLeft > 0);
    setShowRightShadow(scrollLeft < scrollWidth - clientWidth - 1);
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      handleScroll();

      container.addEventListener('scroll', handleScroll);

      const resizeObserver = new ResizeObserver(handleScroll);
      resizeObserver.observe(container);

      return () => {
        container.removeEventListener('scroll', handleScroll);
        resizeObserver.disconnect();
      };
    }
  }, [apiData]);

  if (loading) {
    return <AllTestsListSkeleton />;
  }
  return (
    <main className=" md:border-none py-3 px-4 md:px-2">
      <div className="flex w-full flex-col space-y-6 md:space-y-3">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">
            <span className="text-[var(--q3-neutral-default)]">AYJR Papers</span>
          </h1>
        </div>
        {apiData?.subgroups[0]?.tests?.map((test, idx) => (
          <TestListingCard packId={packId} test={test?.test} isPackPurchased={true} index={idx} navigate={navigate} />
        ))}
      </div>
    </main>
  );
}
